import {http} from "../utils/http";

export const getDeviceDetails = async (id) => {
    try {
        return await http.get(`/Device/${id}`);
    } catch (error) {}
};
